<template>
     <div :class="{
            'address mt-4 position-relative w-100 d-inline-block' : true,
            'w-5 float-left' : arrParam.type == 1 &&  $detect == 'mobile',
            'pd-5' : arrParam.type == 3 &&  $detect == 'mobile'
        }">
        <div :class="{
                'input-focus-effect position-relative': true,
                'rv-valiadate-input-form': error
            }" v-if="arrParam.type != 1">
            <!-- <select class="udt_type-0_9" name="" v-if="arrParam.type == 1" v-model="param" @change="push(arrParam.data)">
            	<option v-for="(index, key) in arrParam.data" :key="key" :value="index.id" >{{index.name}}</option>
            </select> -->
            <input type="number" name="" value="" @change="push(arrParam)" placeholder="" v-if="arrParam.type == 7" v-model="param">
            <input type="text" name="" value="" @change="push(arrParam)" placeholder="" v-if="arrParam.type == 4" v-model="param">
            <label :class="{
                    'mb-0': true,
                    'input-focus-effect bg-white': true && arrParam.type == 3,
                    'input-on-alue': param != '' || arrParam.type == 2 || param >= 0
                }">{{ name }}</label>
        </div>
        <div v-if="arrParam.type == 6" class="d-flex w-100 type-6">
             <div class="box-btn-x text-center w-50" >
                 <div :class="{
                        'active' : param == 1
                    }" @click="select(1)">Có</div>
            </div>
            <div class="box-btn-x text-center w-50" >
                <div :class="{
                        'active' : param == 0
                    }" @click="select(0)">Không</div>
            </div>
        </div>
       
        <textarea :class="param != '' ? 'border-primary' : ''" class="w-100 p-2" @change="push(arrParam)" id="inputOtherInfo" v-if="arrParam.type == 3"
                v-model="param" rows="3"></textarea>
        <div class="select-up-detail p-10" v-if="arrParam.type == 2">
            <ldc-select-show-option
                :showPlaceholder="false"
                :multiple="true"
                v-model="arrType2">
                <ldc-option-show
                    v-for="(item, index) in arrParam.data" :key="index"
                    :value="item.id"
                    :label="item.name"/>
            </ldc-select-show-option>
        </div>
         
        <ldc-select 
            v-model="param"
            placeholder=""
            @change="push(arrParam.data)"
            class="rv-select-form" v-if="$detect == 'web' && arrParam.type == 5">
            <ldc-option
                v-for="(index, key) in arrParam.data" :key="key"
                :value="index.id"
                :label="index.name"/>
        </ldc-select>
        <ldc-select-mobile
            :showPlaceholder="false"
            v-model="param"
            class="select-mobile-post"
            @change="push(arrParam.data)"
            v-if="$detect == 'mobile' && (arrParam.type == 1 || arrParam.type == 5)"
            :placeholder="name"
            :title="name"
            >
            <ldc-option-mobile
                v-for="(index, key) in arrParam.data" :key="key"
                :value="index.id"
                :label="index.name"/>
        </ldc-select-mobile>
        <autocomplete :items="arrParam.data" :param.sync="paramType" @change="push(arrParam.data)" v-if="$detect == 'web' && arrParam.type == 1 "/>
        <div :class="{
            'text-position-select position-absolute text-primary' :true, 
            'font-13px' : $detect == 'mobile'
            }" v-if="arrParam.type == 1">{{name}}</div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
// 1 : combobox
//         2 : multi combobox
//         3 : texarea
//         4 : input-text
//         5 : select
//         6 : input -checkbox
        // 7 : input-text(int)
export default {
    components: {
        autocomplete: () => import('@/components/profile/create/autocomplete'),
    },
    props: ['data', 'error','type','name', 'dpram'],
    data() {
        return {
            paramType : 0,
            arrParam: '',
            arrType2 : [],
            param : '',
            text : [],
            active : false
        }
    },
    watch: {
        text(val){
            this.$emit('update:dpram', val);
        },
        arrType2(val){
            let param = {};
            let data = [...val];
            let md5 = '';
            if(data.length > 0){
                this.arrParam.data.map((item,key) => {
                    if(data[0] == item.id){
                         param[item.md5] = data;
                         md5 = item.md5;
                    }
                });

                this.text.map((item,key) => {
                    if(item[md5]){
                          item[md5] = data;
                          this.active = true;
                    }
                })   
                if(!this.active) this.text.unshift(param)
            }else{
                this.text = [];
            }
        },
        paramType(val){
            let param = {};
            this.arrParam.data.map(item => {
                if(item.id == val){
                    param[item.md5] = val;
                    this.check(item.md5, 1);
                }
            })
         
            if(!this.active) this.text.unshift(param)
        }
    },
    created() {
        this.text = this.dpram;
        this.arrParam = this.data
        if(this.arrParam.type == 1 || this.arrParam.type == 5){
            this.param = this.arrParam.active[0];
            this.paramType =  this.arrParam.active[0];
            if(this.arrParam.active[0] != 0)  this.push(this.arrParam.data)
        }
        if(this.arrParam.type == 2){
            if(this.arrParam.active.length > 0){
                this.arrType2 = this.arrParam.active;
            }
        }
        if(this.arrParam.type == 3 || this.arrParam.type == 4 ){
            this.param = this.arrParam.data.value;
            if(this.arrParam.data.value != '') this.push(this.arrParam)
        }
        if(this.arrParam.type == 7){
            this.param = this.arrParam.data.value;
            this.push(this.arrParam)
        }
        if(this.arrParam.type == 6){
            this.param = this.arrParam.data.value;
        }
    },
    methods : {
        push(data){
            console.log('ok')
            let param = {};
            if(Array.isArray(data)){
                data.map(item => {
                    if(item.id == this.param){
                          param[item.md5] = this.param;
                          this.check(item.md5);
                    }
                })
            }else{
                   param[data.data.md5] = this.param;
                   this.check(data.data.md5);
            }
            if(!this.active) this.text.unshift(param)
           
        },
        select(numb){
            let param = {};
            this.param = numb;
            param[this.arrParam.data.md5] = numb;
            this.check(this.arrParam.data.md5);
            if(!this.active) this.text.unshift(param)

        },
        check(md5, type = 0){
            let check = 0;
            if(type == 1){
                check = this.paramType;
            }else{
                check = this.param;
            }
            this.text.map((item,key) => {
                if(item[md5]){
                      item[md5] = check;
                      this.active = true;
                      return
                }
            })        
        }
    }
}
</script>
<style lang='scss'>
    .type-6{
        padding: 10px;
        .box-btn-x{
            div{
                width: 80px;
                border-radius: 50%;
                border: 1px solid #e5e5e5;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 auto;
                &.active{
                    background: #28a745;
                    color: white;
                    border: 1px solid #28a745;
                }
            }
        }
    }
    .pd-5{
        padding : 0 5px;
    }
    .font-13px{
        font-size : 13px;
    }

    .w-5{
        width: 48% !important;
        margin-left: 5px;
    }
    .p-10{
        padding: 10px 0;
    }
    .udt_type-0_9{
        border: 1px solid rgba(0, 0, 0, 0.2) !important;
        color: #000;
        font-size: 16px !important;
        height: unset !important;
        line-height: unset !important;
        padding: 10px !important;
       width: 100%;
    } 
</style>
